// extracted by mini-css-extract-plugin
export default {"layout":"_6160f72b97 _9b048a1966 _85947d6dbc","h_slide":"f957783c8d","category":"eb289aa455 _862be7c702 _5237373e0e"};